module.exports = __webpack_public_path__ + "img/robot2.5873d608.png";